import { docSessionStorage } from '@growth/browser-storage';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var mangleCardMap = function mangleCardMap(defaultCards, customCards) {
  if (defaultCards === void 0) {
    defaultCards = new Map();
  }

  var cardMaps = defaultCards;

  if (customCards && (customCards == null ? void 0 : customCards.size) > 0) {
    cardMaps = new Map([].concat(Array.from(defaultCards.entries()), Array.from(customCards.entries())));
  }

  return cardMaps;
};
/** get card component for skywalker template */


var getTemplateComponents = function getTemplateComponents(opts) {
  var templateId = opts.templateId,
      customRendererCollection = opts.customRendererCollection,
      rendererCollection = opts.rendererCollection;
  /** Allow rendring any custom cards from outside of @skywalker/card packages
    *  use-cases:
    *  * Render the adtech card form adtech sdk which is not part of skywalker cards/package
    */

  var cardMaps = mangleCardMap(rendererCollection, customRendererCollection);
  return cardMaps.get(templateId);
};
/** get data for a template */


var getDataForTemplate = function getDataForTemplate(skywalkerSequenceData, cardId) {
  return skywalkerSequenceData[cardId];
};

var getTemplate = function getTemplate(seq, rendererCollection, customRendererCollection) {
  // get the UI component for skywalker template.id
  var templateId = seq.template.id;
  var templateComponent = getTemplateComponents({
    templateId: templateId,
    rendererCollection: rendererCollection,
    customRendererCollection: customRendererCollection
  });
  return templateComponent;
};

var getTemplateData = function getTemplateData(seq, skywalkerData) {
  // get the data for above UI component
  var dataId = seq.id;
  var templateData = getDataForTemplate(skywalkerData, dataId);
  return templateData;
};

var generateCardsSequence = function generateCardsSequence(opts) {
  var skywalkerSequence = opts.skywalkerSequence,
      skywalkerData = opts.skywalkerData,
      globalData = opts.globalData,
      rendererCollection = opts.rendererCollection,
      customRendererCollection = opts.customRendererCollection;
  var cardSequence = {
    globalData: globalData,
    cardItems: []
  };
  skywalkerSequence.forEach(function (seq) {
    var templateComponent = getTemplate(seq, rendererCollection, customRendererCollection);
    var templateData = getTemplateData(seq, skywalkerData);
    cardSequence.cardItems.push({
      component: templateComponent,
      backend: {
        data: templateData,
        metadata: {
          seq: seq
        }
      }
    }); // for nested card sequences , parent card's backend object is updated with nested cards' template id
    // acting as keys and  their values as nested template data

    if (seq != null && seq.cardSequence) {
      var _seq$cardSequence;

      var nestedCardsSequences = seq == null ? void 0 : (_seq$cardSequence = seq.cardSequence) == null ? void 0 : _seq$cardSequence.data;
      nestedCardsSequences.forEach(function (nestedSeq) {
        var nestedTemplateData = getTemplateData(nestedSeq, skywalkerData);
        var parentCard = cardSequence.cardItems.pop();

        if (parentCard) {
          parentCard.backend.data.data[nestedSeq.template.id] = nestedTemplateData;
          cardSequence.cardItems.push(parentCard);
        }
      });
    }
  });
  return cardSequence;
};

var SKYWALKER_TEMPLATE_ID_GROWTH_MWEB = {
  offerMweb: 'OFFERSV2',
  whatsNewMweb: 'BANNER',
  covidMweb: 'COVID',
  tripMweb: 'TRIPMONEY',
  festivalMweb: 'FESTIVAL',
  guestLoginMweb: 'GUEST',
  gotribeGuestMweb: 'GOTRIBE_GUEST',
  gotribeUserMweb: 'GOTRIBE_USER',
  dsdContainerMweb: 'DSD_CONTAINER',
  thinBanner: 'GOGAMES',
  adTechMweb: 'ADTECH',
  mweb2appInline: 'MWEB2APP_INLINE_CARD',
  dsdHotelMweb: 'DSD_HOTEL',
  dsdHotelDweb: 'DSD_HOTEL',
  dsdFlightMweb: 'DSD_FLIGHT',
  dsdFlightDweb: 'DSD_FLIGHT',
  dropoffHotelsMweb: 'DROPOFF_ACTION_HOTEL_V2',
  dropoffFlightMweb: 'DROPOFF_ACTION_FLIGHT_V2',
  recentSearchMweb: 'GI_RECENT_SEARCH'
};
var SKYWALKER_TEMPLATE_ID_GROWTH_DWEB = {
  featuredOffersDweb: 'OFFERSV2',
  dsdContainerDweb: 'DSD_CONTAINER',
  gosafeDesktop: 'GOSAFEDESKTOP',
  adTechDweb: 'ADTECH',
  recentSearchDweb: 'GI_RECENT_SEARCH'
};
var SKYWALKER_API_PATHS_GROWTH = {
  pwaHome: '/pwahome',
  desktopHome: '/desktophome'
};

var TabIds = {
  hotels: 'DSD_HOTEL',
  flights: 'DSD_FLIGHT'
};
var CardTypes = {
  locator: 'citylocator',
  viewAll: 'viewAll',
  template: 'template'
};
var DISCOUNT_TEXT = 'OFF';
var FlightSearchType = {
  recent: 'Recent',
  top: 'TopMost'
};
var locationSession = {
  dsdHtl: 'dsdHtl',
  dsdFlt: 'dsdFlt'
};

var getDSDHotelSearch = function getDSDHotelSearch() {
  return docSessionStorage.getItem(locationSession.dsdHtl);
};

var getDSDFlightSearch = function getDSDFlightSearch() {
  return docSessionStorage.getItem(locationSession.dsdFlt);
}; // could use this to generate extrareqbody params for hotel/flights dsd, while
// making an api call to skywalker


var generateHotelDsdLocation = function generateHotelDsdLocation(_ref) {
  var _userLocationsCopy$cu, _userSavedLocation$lo, _userSavedLocation$lo2, _userSavedLocation$lo3, _userSavedLocation$lo4, _userSavedLocation$lo5, _userSavedLocation$lo6, _userSavedLocation$lo7, _userSavedLocation$lo8, _userSavedLocation$lo9, _userSavedLocation$lo10, _userSavedLocation$lo11;

  var _ref$id = _ref.id,
      id = _ref$id === void 0 ? '' : _ref$id,
      _ref$lat = _ref.lat,
      lat = _ref$lat === void 0 ? '' : _ref$lat,
      _ref$lng = _ref.lng,
      lng = _ref$lng === void 0 ? '' : _ref$lng,
      _ref$city = _ref.city,
      city = _ref$city === void 0 ? '' : _ref$city,
      _ref$isCurrentLocatio = _ref.isCurrentLocation,
      isCurrentLocation = _ref$isCurrentLocatio === void 0 ? false : _ref$isCurrentLocatio,
      _ref$flightCity = _ref.flightCity,
      flightCity = _ref$flightCity === void 0 ? '' : _ref$flightCity,
      _ref$userLocations = _ref.userLocations,
      userLocations = _ref$userLocations === void 0 ? {} : _ref$userLocations;
  if (!id && !lat && !flightCity) return null;

  var userLocationsCopy = _extends({}, userLocations);

  var userSavedLocation = userLocationsCopy == null ? void 0 : (_userLocationsCopy$cu = userLocationsCopy.current) == null ? void 0 : _userLocationsCopy$cu.user;
  var hotelDsdLocation = {
    // user's hotel dsd location is created inside user object.
    user: {
      loginChannel: 'GI',
      location: {
        locationData: {
          lastISPLocation: {
            lat: lat || (userSavedLocation == null ? void 0 : (_userSavedLocation$lo = userSavedLocation.location) == null ? void 0 : (_userSavedLocation$lo2 = _userSavedLocation$lo.locationData) == null ? void 0 : (_userSavedLocation$lo3 = _userSavedLocation$lo2.lastISPLocation) == null ? void 0 : _userSavedLocation$lo3.lat) || '',
            lng: lng || (userSavedLocation == null ? void 0 : (_userSavedLocation$lo4 = userSavedLocation.location) == null ? void 0 : (_userSavedLocation$lo5 = _userSavedLocation$lo4.locationData) == null ? void 0 : (_userSavedLocation$lo6 = _userSavedLocation$lo5.lastISPLocation) == null ? void 0 : _userSavedLocation$lo6.lng) || ''
          }
        },
        dealsCity: {
          id: isCurrentLocation ? '' : id || (userSavedLocation == null ? void 0 : (_userSavedLocation$lo7 = userSavedLocation.location) == null ? void 0 : (_userSavedLocation$lo8 = _userSavedLocation$lo7.dealsCity) == null ? void 0 : _userSavedLocation$lo8.id) || '',
          city: isCurrentLocation ? '' : city || (userSavedLocation == null ? void 0 : (_userSavedLocation$lo9 = userSavedLocation.location) == null ? void 0 : (_userSavedLocation$lo10 = _userSavedLocation$lo9.dealsCity) == null ? void 0 : _userSavedLocation$lo10.city) || '',
          isCurrentLocation: isCurrentLocation
        },
        dealsSector: flightCity || (userSavedLocation == null ? void 0 : (_userSavedLocation$lo11 = userSavedLocation.location) == null ? void 0 : _userSavedLocation$lo11.dealsSector) || ''
      }
    }
  };
  return hotelDsdLocation;
};

var appendZero = function appendZero(num) {
  if (num <= 0) return "00";
  return num < 10 ? "0" + num : "" + num;
};

var getDsdCardDataStructure = function getDsdCardDataStructure(cardData) {
  // hotels cards data which has locator data , hotels data and view all data.
  var locatorData = cardData.filter(function (item) {
    return item.cardType === CardTypes.locator;
  })[0];
  var viewAllData = cardData.filter(function (item) {
    return item.cardType === CardTypes.viewAll;
  })[0];
  var cardsData = cardData.filter(function (item) {
    return item.cardType === CardTypes.template;
  });
  return {
    locatorData: locatorData,
    viewAllData: viewAllData,
    cardsData: cardsData
  };
};

var generateDsdCardData = function generateDsdCardData(skywalkerApiResponse, isDesktop) {
  var _dsdResponse$cardItem, _dsdResponse$cardItem2, _dsdResponse$cardItem3, _dsdResponse$cardItem4;

  var _ref2 = skywalkerApiResponse || {},
      _ref2$sequence = _ref2.sequence,
      sequence = _ref2$sequence === void 0 ? [] : _ref2$sequence,
      _ref2$data = _ref2.data,
      data = _ref2$data === void 0 ? [] : _ref2$data,
      _ref2$globalData = _ref2.globalData,
      globalData = _ref2$globalData === void 0 ? {} : _ref2$globalData;

  var dsdContainrTemplatedId = isDesktop ? SKYWALKER_TEMPLATE_ID_GROWTH_DWEB.dsdContainerDweb : SKYWALKER_TEMPLATE_ID_GROWTH_MWEB.dsdContainerMweb;
  var dsdSequence = sequence.filter(function (seq) {
    var _seq$template;

    return (seq == null ? void 0 : (_seq$template = seq.template) == null ? void 0 : _seq$template.id) === dsdContainrTemplatedId;
  });
  var dsdResponse = generateCardsSequence({
    skywalkerSequence: dsdSequence,
    skywalkerData: data,
    globalData: globalData
  });
  return (dsdResponse == null ? void 0 : (_dsdResponse$cardItem = dsdResponse.cardItems) == null ? void 0 : (_dsdResponse$cardItem2 = _dsdResponse$cardItem[0]) == null ? void 0 : (_dsdResponse$cardItem3 = _dsdResponse$cardItem2.backend) == null ? void 0 : (_dsdResponse$cardItem4 = _dsdResponse$cardItem3.data) == null ? void 0 : _dsdResponse$cardItem4.data) || {};
};

var getUserLastHotelFlightLocation = function getUserLastHotelFlightLocation() {
  var hotelLocation = getDSDHotelSearch();
  var flightLocation = getDSDFlightSearch();
  if (!hotelLocation && !flightLocation) return {};
  var location = {
    isCurrentLocation: (hotelLocation == null ? void 0 : hotelLocation.isCurrentLocation) || false
  };

  if (hotelLocation) {
    if (hotelLocation.isCurrentLocation) {
      location.lat = hotelLocation == null ? void 0 : hotelLocation.id;
      location.lng = hotelLocation == null ? void 0 : hotelLocation.city;
    } else {
      location.id = hotelLocation == null ? void 0 : hotelLocation.id;
      location.city = hotelLocation == null ? void 0 : hotelLocation.city;
    }
  }

  if (flightLocation) {
    location.flightCity = flightLocation.id;
  }

  var userHotelFlightLocation = generateHotelDsdLocation(location) || {};
  return userHotelFlightLocation;
};

export { DISCOUNT_TEXT as D, FlightSearchType as F, SKYWALKER_TEMPLATE_ID_GROWTH_DWEB as S, TabIds as T, _extends as _, generateCardsSequence as a, SKYWALKER_API_PATHS_GROWTH as b, SKYWALKER_TEMPLATE_ID_GROWTH_MWEB as c, appendZero as d, getDsdCardDataStructure as e, generateDsdCardData as f, getUserLastHotelFlightLocation as g, generateHotelDsdLocation as h };
